export default __webpack_public_path__ + "static/media/176shots_so.2f53f4fd.png";